import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDemote = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 410 512",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M164.532 338.853C167.84 342.16 173.28 342.16 176.588 338.853C179.895 335.546 179.895 330.105 176.588 326.798L29.0445 179.148H333.5C366.465 179.148 393 205.926 393 238.891L393.035 503.465C393.035 508.159 396.806 512 401.5 512C406.194 512 410 508.159 410 503.465V239C410 196.54 375.96 162.079 333.5 162.079H29.0445L176.694 14.5356C180.001 11.2284 180.001 5.78757 176.694 2.48039C173.387 -0.826796 167.946 -0.826796 164.639 2.48039L2.48039 164.639C-0.826796 167.946 -0.826796 173.387 2.48039 176.694L164.639 338.853H164.532Z" })
});
export default SvgDemote;
